import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Manager, Target, Popper } from 'react-popper';

// Styling
import { withStyles } from 'material-ui/styles';
import styles from './styles';

// Material UI
import Grow from 'material-ui/transitions/Grow';
import Paper from 'material-ui/Paper';
import ClickAwayListener from 'material-ui/utils/ClickAwayListener';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import { MenuItem, MenuList } from 'material-ui/Menu';

// Actions
import { openMoreInfo } from './actions';

const options = [
  'Terms & Conditions',
  'Help',
  'Log Out',
];

class MoreInfo extends Component {
  render(){
    const { classes } = this.props;
    return(
      <div className={classes.firstDiv}>
        <IconButton
           aria-owns={this.props.moreInfoOpen ? 'menu-list' : null}
           aria-haspopup="true"
           onClick={() => this.props.openMoreInfo(true)}
           className={classes.menuIcon}
        >
          <MoreVertIcon />
        </IconButton>
        <Manager>
          <Target>
          </Target>
          <Popper placement="bottom-start" eventsEnabled={this.props.moreInfoOpen}>
            <ClickAwayListener onClickAway={this.handleRequestClose}>
              <Grow in={this.props.moreInfoOpen} id="menu-list" style={{ transformOrigin: '0 0 0' }}>
                <Paper>
                  <MenuList className={classes.menuList} role="menu">
                    <MenuItem disableRipple onClick={() => this.props.openMoreInfo(false)}>Terms & Conditions</MenuItem>
                    <MenuItem disableRipple onClick={() => this.props.openMoreInfo(false)}>Privacy Policy</MenuItem>
                    <MenuItem disableRipple onClick={() => this.props.openMoreInfo(false)}>Logout</MenuItem>
                  </MenuList>
                </Paper>
              </Grow>
            </ClickAwayListener>
          </Popper>
        </Manager>
      </div>
    );
  }
}

MoreInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        moreInfoOpen: state.dashboard.moreInfoOpen,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        openMoreInfo: openMoreInfo,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(MoreInfo));



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/components/ToolBar/components/MoreInfo/index.js